// extracted by mini-css-extract-plugin
export var iconContainer = "style-module--iconContainer--buxAI";
export var xxsmall = "style-module--xxsmall--E9KGS";
export var xsmall = "style-module--xsmall--Hm5dX";
export var small = "style-module--small--VZJUr";
export var normal = "style-module--normal--T53Rv";
export var medium = "style-module--medium--zRE39";
export var large = "style-module--large--Ks8SX";
export var xlarge = "style-module--xlarge--jjGj-";
export var icon = "style-module--icon--CD3OO";